// extracted by mini-css-extract-plugin
export default {"lessonsContent":"Lesson_lessonsContent__wqMpT","formControl":"Lesson_formControl__+qbX0","isApproved":"Lesson_isApproved__cSuOW"};